import { initNavigation } from "./scripts/navigation.js";

window.addEventListener("load", () => {
  initNavigation();
});
